/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */


import Store from "./store";
import map from "fj-map";

export default AdmingOrgStore;

function AdmingOrgStore(api) {
	var store = new Store();
	reset();
	return store;

	function reset(){
		api.admin.org.all()
			.then(map(set_org));
	}

	function set_org(group){
		store.set(group._id, group);
	}
}
